<template>
  <b-overlay
    :show="busy"
    variant="dark"
  >
    <b-card-body>
      <b-card-title>Geen unit gevonden met keuringsnummer {{ keuringsnummer }}!</b-card-title>
      <b-card-text>
        Mogelijk was op het moment dat het keuringsrapport werd opgehaald er geen unit 
        (of meerdere units) bekend binnen transplan met het keuringsnummer.
      </b-card-text>
    </b-card-body>

    <slot />

    <b-card-footer>
      <b-button
        block
        variant="primary"
        @click="tryMatchUnit"
      >
        <i class="fa fa-refresh" />
        Zoek nu opnieuw
      </b-button>
    </b-card-footer>
  </b-overlay>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin";
export default {
    name: "KeuringrapportMatch",
    mixins: [serviceMixin],
    props: {
        keuringsnummer: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            busy: false
        };
    },
    methods: {
        tryMatchUnit() {
            this.$emit("tryMatchUnit", this.keuringsnummer);
        }
    }
}
</script>